import { useHerdControlAnalytics } from "features/shared/hooks/useHerdControlAnalytics";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  createHerdRecord,
  deleteHerdRecord,
  fetchEnrichedFarmCategories,
  fetchFarmEnrichedHerdRecords,
  fetchOperationTypes,
  updateHerdRecord,
} from "redux/operations";
import { RootState } from "redux/reducers";
import MovementsPage from "./movementsPage";

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

type MovementsContainerProps = StateProps & DispatchProps;

function MovementsContainer({
  createHerdRecord,
  deleteHerdRecord,
  enrichedFarmCategories,
  farmEnrichedHerdRecords,
  fetchEnrichedFarmCategories,
  fetchFarmEnrichedHerdRecords,
  fetchOperationTypes,
  operationTypes,
  updateHerdRecord,
}: MovementsContainerProps) {
  const { trackEvent } = useHerdControlAnalytics({
    tabName: "Entrada e Saida",
  });

  useEffect(() => {
    trackEvent();

    // We want to run this only once on component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchFarmEnrichedHerdRecords();
    fetchOperationTypes();
    fetchEnrichedFarmCategories(false);

    // We want to run this only once on component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreateHerdRecord = async (
    ...params: Parameters<typeof createHerdRecord>
  ) => {
    await Promise.resolve(createHerdRecord(...params));
    // Ensure record is created before refetching
    fetchFarmEnrichedHerdRecords();
  };

  const handleUpdateHerdRecord = async (
    ...params: Parameters<typeof updateHerdRecord>
  ) => {
    await Promise.resolve(updateHerdRecord(...params));
    // Ensure record is updated before refetching
    fetchFarmEnrichedHerdRecords();
  };

  const handleDeleteHerdRecord = async (
    ...params: Parameters<typeof deleteHerdRecord>
  ) => {
    await Promise.resolve(deleteHerdRecord(...params));
    // Ensure record is deleted before refetching
    fetchFarmEnrichedHerdRecords();
  };

  return (
    <MovementsPage
      enrichedFarmCategories={enrichedFarmCategories}
      createHerdRecord={handleCreateHerdRecord}
      deleteHerdRecord={handleDeleteHerdRecord}
      farmEnrichedHerdRecords={farmEnrichedHerdRecords}
      operationTypes={operationTypes}
      updateHerdRecord={handleUpdateHerdRecord}
    />
  );
}

const mapStateToProps = (state: RootState) => ({
  enrichedFarmCategories: state.category.enrichedFarmCategories,
  farmEnrichedHerdRecords: state.movements.farmEnrichedHerdRecords,
  operationTypes: state.movements.operationTypes,
});

const mapDispatchToProps = {
  createHerdRecord,
  deleteHerdRecord,
  fetchEnrichedFarmCategories,
  fetchFarmEnrichedHerdRecords,
  fetchOperationTypes,
  updateHerdRecord,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(MovementsContainer);
